import { Type1 } from './Type1';

/**
 * confirm_number_pressed
 * тап на активную кнопку "Получить код" / "Далее"
 */
export interface ConfirmNumberPressed {
  type: Type1;
}

export function mapConfirmNumberPressedEvent(event: ConfirmNumberPressed): object {
  const props: Record<string, unknown> = {
      type: event.type,
  };

  return {
    event: 'analytics_event',
    event_name: 'confirm_number_pressed',
    event_properties: Object.fromEntries(
      Object.entries(props)
        .filter(([_, v]) => v != null)
        .map(([k, v]) => [k, String(v)])
    ),
  };
}
